import { inIframe } from '@iheartjane/utils';
import { useEffect, useRef } from 'react';

import { postMessageToIframeParent } from '@jane/shared/util';

export const useHandleIframeModal = (
  isOpen: boolean,
  scrollPosition?: boolean
) => {
  const wasOpen = useRef(false);
  const isInIframe = inIframe();

  useEffect(() => {
    if (isInIframe) {
      if (isOpen && !wasOpen.current) {
        if (scrollPosition) {
          postMessageToIframeParent({
            messageType: 'saveScrollPosition',
          });
        }

        postMessageToIframeParent({
          messageType: 'enableShrinkEveryResize',
        });

        postMessageToIframeParent({
          messageType: 'openModal',
        });

        postMessageToIframeParent({
          messageType: 'scrollToTop',
        });
      }

      if (!isOpen && wasOpen.current) {
        postMessageToIframeParent({
          messageType: 'disableShrinkEveryResize',
        });

        postMessageToIframeParent({
          messageType: 'closeModal',
        });

        if (scrollPosition) {
          postMessageToIframeParent({
            messageType: 'restoreScrollPosition',
            payload: 'smooth',
          });
        }
      }
    }

    wasOpen.current = isOpen;
  }, [isOpen, isInIframe, scrollPosition]);
};

export const useIframeScroll = (isOpen: boolean) => {
  useEffect(() => {
    if (isOpen) {
      postMessageToIframeParent({
        messageType: 'scrollToTop',
      });
    }
  }, [isOpen]);
};
